/*--------------------------------------------------------------
# Mobile Menu
--------------------------------------------------------------*/
const mobileMenu = document.getElementById('mobile-menu');
if (mobileMenu != null)
{
    let mobileVisible = false;

    // Open the mobile menu
    function openMobileMenu()
    {
        document.getElementById('mobile-wrapper').classList.add('active');
        mobileVisible = true;
    }

    const triggerOpenMobileMenu = document.getElementById('open-mobile-menu');
    triggerOpenMobileMenu.addEventListener('click', () =>
    {
        openMobileMenu();
    });

    // Close the mobile menu
    function closeMobileMenu()
    {
        document.getElementById('mobile-wrapper').classList.remove('active');
        mobileVisible = false;
    }

    const triggerCloseMobileMenu = document.getElementById('close-mobile-menu');
    triggerCloseMobileMenu.addEventListener('click', () =>
    {
        closeMobileMenu();
    });

    document.onkeydown = function (evt)
    {
        if (mobileVisible) {
            evt = evt || window.event;
            if (evt.key == "Escape")
            {
                closeMobileMenu();
            }
        }
    };
}